import { motion } from "framer-motion";
import { Reveal } from "./Reveal";
import { ADVANTAGES } from "../lib/site";

export const WhyChoose = () => {
  return (
    <section
      id="por-que-glg"
      data-testid="why-choose-section"
      className="noise relative overflow-hidden bg-glg-surface py-24 sm:py-32"
    >
      <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-16 max-w-2xl">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-glg-green">
              Por qué elegir GLG
            </p>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-heading text-3xl font-semibold leading-tight tracking-tight text-white sm:text-5xl">
              Razones para confiar en nosotros
            </h2>
          </Reveal>
        </div>

        <div className="grid gap-px overflow-hidden rounded-3xl border border-white/10 bg-white/5 md:grid-cols-2 lg:grid-cols-3">
          {ADVANTAGES.map((a, i) => (
            <motion.div
              key={a.n}
              data-testid={`advantage-${a.n}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className="group relative bg-glg-black p-8 transition-colors duration-300 hover:bg-glg-surface sm:p-10"
            >
              <span className="font-heading text-5xl font-extrabold leading-none tracking-tighter text-white/10 transition-colors duration-300 group-hover:text-glg-blue/40">
                {a.n}
              </span>
              <h3 className="mt-5 font-heading text-xl font-semibold text-white">
                {a.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-white/55">
                {a.description}
              </p>
              <span className="absolute bottom-0 left-0 h-0.5 w-0 bg-gradient-to-r from-glg-blue to-glg-orange transition-[width] duration-500 group-hover:w-full" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
